import type { Message } from '@/features/messages';
import { cn } from '@/shared/utilities';
import { Typography } from '@mui/material';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

interface MessageListItemForwardProps {
  msg?: Message;
}

const MessageListItemForward = memo<MessageListItemForwardProps>(({ msg }) => {
  const { t } = useTranslation();
  if (!msg?.originalMessageId || msg?.isRevoked) return null;

  return (
    <div
      className={cn(
        'mex:!border-solid mex:!min-h-0 mex:m-2 mex:flex mex:flex-col mex:border-primary mex:border-l-[3px] mex:px-2'
      )}
      aria-label={t('messageList.viewForward')}
    >
      <Typography
        variant='caption'
        color='text.secondary'
        fontWeight='bold'
        className='mex:!text-black mex:dark:!text-white'
      >
        {t('messageList.forwarded')}
      </Typography>
    </div>
  );
});

export { MessageListItemForward };
export default MessageListItemForward;
